import { TPAComponentProps } from '../../types';

export enum AddItemIconSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
  xLarge = 'xLarge',
}

export enum AddItemAlignment {
  center = 'center',
  right = 'right',
  left = 'left',
}

export enum AddItemDirection {
  horizontal = 'horizontal',
  vertical = 'vertical',
}

export interface AddItemProps extends TPAComponentProps {
  /** Applies disabled styles */
  disabled?: boolean;
  /** Applies error styles */
  hasError?: boolean;
  /** Content horizontal alignment */
  alignment?: AddItemAlignment;
  /** Indicates whether to display the content horizontally or vertically */
  direction: AddItemDirection;
  /** Size to control the size of the icon  */
  iconSize?: AddItemIconSize;
  /** Could be any renderable node */
  children?: React.ReactNode;
  /** Click event handler  */
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  /** Defines a string value that labels the add item element. Optional. */
  'aria-label'?: string;
  /** Identifies the element that labels the add item element. Optional. */
  'aria-labelledby'?: string;
}

export interface AddItemDefaultProps {
  disabled: boolean;
  hasError: boolean;
  alignment: AddItemAlignment;
  direction: AddItemDirection;
  iconSize: AddItemIconSize;
}
